/**
 * Returns the approximated date of birth if years and months old are provided.
 * The returned date will always show the first day of the month, since it is unknown.
 *
 *
 * Example: getApproximatedDateOfBirth(10, 7) -> '2010-11-30T23:00:00.000Z' (today being 28th July 2021)
 */

export const getApproximatedDateOfBirth = (yearsOld: number, monthsOld: number = 0) => {
  const currentYear = new Date().getFullYear()
  const currentMonth = new Date().getMonth()

  const oneYearInMonths = 12
  const oneYear = 1

  const getBirthMonth = () => {
    return currentMonth > monthsOld
      ? currentMonth - monthsOld
      : currentMonth + oneYearInMonths - monthsOld
  }

  const birthYear =
    currentMonth > monthsOld ? currentYear - yearsOld : currentYear - yearsOld - oneYear

  return new Date(birthYear, getBirthMonth(), 1).toISOString()
}
